/**
 * Tabs
 *
 * @param {}
 * @return {void}
 */

$(document).on('click', '.js-tabs-link', function(event) {
  event.preventDefault();

  const $this = $(this);
  const $element = $($($this).attr('href'));

  if (!$element.length) {
    return;
  }

  $element
    .add($this.parent())
    .addClass('is-active')
    .siblings('.is-active')
    .removeClass('is-active');
});
